import React, { useEffect, useState } from "react";
import {
  Drawer,
  Input,
  Button,
  Switch,
  message,
  Divider,
  Spin,
  Empty,
  Pagination,
  Modal,
} from "antd";
import { API_BASE_CRM_URL } from "../../Config/Config";
import Swal from "sweetalert2";

const { Search } = Input;
export default function Contacts({ customerId }) {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");

  const [editContactDrawerOpen, setEditContactDrawerOpen] = useState(false);
  const [addContactDrawerOpen, setAddContactDrawerOpen] = useState(false);

  const [editContactLoading, setEditContactLoading] = useState(false);
  const [addContactLoading, setAddContactLoading] = useState(false);

  const [editContactData, setEditContactData] = useState({
    id: "",
    firstname: "",
    lastname: "",
    email: "",
    phonenumber: "",
    title: "",
    is_primary: 0,
    active: 1,
  });

  const [addContactData, setAddContactData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phonenumber: "",
    title: "",
    is_primary: 0,
    active: 1,
  });
  const filteredContacts = contacts.filter((contact) => {
    const search = searchText.toLowerCase();

    return (
      contact?.FullName?.toLowerCase().includes(search) ||
      contact?.email?.toLowerCase().includes(search) ||
      contact?.phonenumber?.toLowerCase().includes(search) ||
      contact?.title?.toLowerCase().includes(search)
    );
  });

  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;

  const fetchContacts = async () => {
    if (!customerId) return;

    setLoading(true);

    try {
      const response = await fetch(
        `${API_BASE_CRM_URL}customers/GetContacts?userid=${customerId}`,
      );

      if (!response.ok) {
        throw new Error("Failed to fetch contacts");
      }

      const data = await response.json();

      if (data.Status) {
        setContacts(data.ResultData || []);
      } else {
        setContacts([]);
      }
    } catch (error) {
      console.error("Error fetching contacts:", error);
      setContacts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContacts();
  }, [customerId]);

  const startIndex = (currentPage - 1) * pageSize;

  const paginatedContacts = filteredContacts.slice(
    startIndex,
    startIndex + pageSize,
  );

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spin size="large" />
      </div>
    );
  }

  if (!contacts.length) {
    return (
      <div className="py-5">
        <Empty description="No Contacts Found" />
      </div>
    );
  }

  const handleEditContact = (contact) => {
    setEditContactData({
      id: contact.id,
      firstname: contact.firstname || "",
      lastname: contact.lastname || "",
      email: contact.email || "",
      phonenumber: contact.phonenumber || "",
      title: contact.title || "",
      is_primary: contact.is_primary || 0,
      active: contact.active || 1,
    });

    setEditContactDrawerOpen(true);
  };

  const handleEditContactChange = (e) => {
    const { name, value } = e.target;

    setEditContactData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddContactChange = (e) => {
    const { name, value } = e.target;

    setAddContactData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddContact = async () => {
    try {
      setAddContactLoading(true);

      const payload = {
        userid: customerId,
        firstname: addContactData.firstname,
        lastname: addContactData.lastname,
        email: addContactData.email,
        phonenumber: addContactData.phonenumber,
        title: addContactData.title,
        is_primary: addContactData.is_primary,
        active: addContactData.active,
      };

      const response = await fetch(`${API_BASE_CRM_URL}customers/AddContact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (data.Status) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 2000,
          showConfirmButton: false,
        });

        setAddContactDrawerOpen(false);

        setAddContactData({
          firstname: "",
          lastname: "",
          email: "",
          phonenumber: "",
          title: "",
          is_primary: 0,
          active: 1,
        });

        fetchContacts();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.Message,
        });
      }
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to add contact",
      });
    } finally {
      setAddContactLoading(false);
    }
  };

  const handleUpdateContact = async () => {
    try {
      setEditContactLoading(true);

      const response = await fetch(
        `${API_BASE_CRM_URL}customers/UpdateContact`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(editContactData),
        },
      );

      const data = await response.json();

      if (data.Status) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 2000,
          showConfirmButton: false,
        });

        setEditContactDrawerOpen(false);
        fetchContacts();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.Message,
        });
      }
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update contact",
      });
    } finally {
      setEditContactLoading(false);
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-12 d-flex align-items-center justify-content-between mb-3">
          <Search
            size="large"
            placeholder="Search "
            allowClear
            // size="medium"
            onChange={(e) => {
              setSearchText(e.target.value);
              setCurrentPage(1);
            }}
          />
          <button
            className="btn btn-sm btn-primary ms-2 mt-1"
            onClick={() => setAddContactDrawerOpen(true)}
          >
            <i className="fa fa-solid fa-plus"></i>
          </button>
        </div>
        {!paginatedContacts?.length && (
          <Empty description="No Contacts Found" />
        )}
        {paginatedContacts.map((contact) => (
          <div className="col-md-6 col-lg-4 mb-3" key={contact.id}>
            <div className="card border-0 shadow-sm">
              <div className="card-body">
                {/* Name & Title */}
                <div className="d-flex justify-content-between align-items-start mb-2">
                  <div className="d-flex align-items-start">
                    <i className="fas fa-user text-muted me-2 mt-1"></i>

                    <div>
                      <h6 className="mb-0 fw-bold">
                        {contact.FullName || "N/A"}
                      </h6>

                      <small className="text-muted">
                        {contact.title || "No Title"}
                      </small>
                    </div>
                  </div>

                  <i
                    className="fas fa-pen-to-square text-primary"
                    style={{
                      cursor: "pointer",
                      fontSize: "15px",
                    }}
                    onClick={() => handleEditContact(contact)}
                  />
                </div>

                {/* Email & Phone */}
                <div className="d-flex flex-wrap align-items-center gap-3">
                  <div>
                    <i className="fas fa-envelope text-muted me-1"></i>
                    <span>{contact.email || "N/A"}</span>
                  </div>

                  <div>
                    <i className="fas fa-phone text-success me-1"></i>
                    <span>{contact.phonenumber || "N/A"}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {contacts.length > pageSize && (
        <div className="d-flex justify-content-center mt-3">
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={contacts.length}
            showSizeChanger={false}
            onChange={(page) => setCurrentPage(page)}
          />
        </div>
      )}

      <Modal
        open={editContactDrawerOpen}
        footer={null}
        onCancel={() => setEditContactDrawerOpen(false)}
        centered
        width={600}
        destroyOnClose
        title={
          <>
            <i className="fas fa-user-edit me-2"></i>
            Edit Contact
          </>
        }
      >
        <div className="row g-2">
          <div className="col-6">
            <Input
              name="firstname"
              value={editContactData.firstname}
              onChange={handleEditContactChange}
              size="large"
              placeholder="Enter First Name"
              prefix={<i className="fas fa-user"></i>}
            />
          </div>

          <div className="col-6">
            <Input
              name="lastname"
              value={editContactData.lastname}
              onChange={handleEditContactChange}
              size="large"
              placeholder="Enter Last Name"
              prefix={<i className="fas fa-user"></i>}
            />
          </div>

          <div className="col-12">
            <Input
              name="email"
              value={editContactData.email}
              onChange={handleEditContactChange}
              size="large"
              placeholder="Enter Email"
              prefix={<i className="fas fa-envelope"></i>}
            />
          </div>

          <div className="col-6">
            <Input
              name="phonenumber"
              value={editContactData.phonenumber}
              onChange={handleEditContactChange}
              size="large"
              placeholder="Enter Phone Number"
              prefix={<i className="fas fa-phone"></i>}
            />
          </div>

          <div className="col-6">
            <Input
              name="title"
              value={editContactData.title}
              onChange={handleEditContactChange}
              size="large"
              placeholder="Enter Title"
              prefix={<i className="fas fa-briefcase"></i>}
            />
          </div>
        </div>

        <div className="text-end mt-4">
          <Button
            type="primary"
            loading={editContactLoading}
            onClick={handleUpdateContact}
          >
            Update
          </Button>
        </div>
      </Modal>

      <Modal
        open={addContactDrawerOpen}
        footer={null}
        onCancel={() => setAddContactDrawerOpen(false)}
        centered
        width={600}
        destroyOnClose
        title={
          <>
            <i className="fas fa-user-plus me-2"></i>
            Add Contact
          </>
        }
      >
        <div className="row g-2">
          <div className="col-md-6">
            <Input
              name="firstname"
              value={addContactData.firstname}
              onChange={handleAddContactChange}
              size="large"
              placeholder="Enter First Name"
              prefix={<i className="fas fa-user"></i>}
            />
          </div>

          <div className="col-md-6">
            <Input
              name="lastname"
              value={addContactData.lastname}
              onChange={handleAddContactChange}
              size="large"
              placeholder="Enter Last Name"
              prefix={<i className="fas fa-user"></i>}
            />
          </div>

          <div className="col-12">
            <Input
              name="email"
              value={addContactData.email}
              onChange={handleAddContactChange}
              size="large"
              placeholder="Enter Email Address"
              prefix={<i className="fas fa-envelope"></i>}
            />
          </div>

          <div className="col-md-6">
            <Input
              name="phonenumber"
              value={addContactData.phonenumber}
              onChange={handleAddContactChange}
              size="large"
              placeholder="Enter Phone Number"
              prefix={<i className="fas fa-phone"></i>}
            />
          </div>

          <div className="col-md-6">
            <Input
              name="title"
              value={addContactData.title}
              onChange={handleAddContactChange}
              size="large"
              placeholder="Enter Job Title"
              prefix={<i className="fas fa-briefcase"></i>}
            />
          </div>
        </div>

        <div className="d-flex justify-content-end gap-2 mt-4">
          <Button onClick={() => setAddContactDrawerOpen(false)}>Cancel</Button>

          <Button
            type="primary"
            loading={addContactLoading}
            onClick={handleAddContact}
          >
            Save
          </Button>
        </div>
      </Modal>
    </>
  );
}
